// extracted by mini-css-extract-plugin
export default {"cls1":"ResearcherList-cls1_svg","cls2":"ResearcherList-cls2_bzc ResearcherList-cls1_svg"};